import type { PaletteOptions, TypeBackground } from '@mui/material/styles';

export const palette: PaletteOptions = {
  bg: '#007232',
  warm_black: '#483B2E',
  juicy_orange_grad: `radial-gradient(50% 100.13% at 50% -0.12%, #FFEA00 0%, #FEBB35 100%)`,
  juicy_green_grad: `radial-gradient(77.94% 100% at 47.16% 0%, #A2E85E 2.38%, #7ACE29 100%)`,

  white_to_white_grad: 'linear-gradient(180deg, rgba(255, 255, 255, 0.90) 0%, rgba(255, 255, 255, 0.65) 100%)',
  white_100: '#FFFFFF',
  white_90: 'rgba(255,255,255,0.9)',
  white_60: 'rgba(255,255,255,0.6)',
  white_20: 'rgba(255,255,255,0.2)',
  white_15: 'rgba(255,255,255,0.15)',
  black_40: 'rgba(0,0,0,0.4)',


  green_black: '#053014',
  juicy_hover_grad: 'radial-gradient(50% 100.13% at 50% -0.12%, #FFEA00 0%, #FED635 100%)',
  glass_yellow_border_grad: 'conic-gradient(from 180deg at 50% 50%, var(--White-20, rgba(255, 255, 255, 0.20)) 1.7291222512722015deg, var(--Neon-Yellow, #F0FF46) 126.34762287139893deg, var(--White-20, rgba(255, 255, 255, 0.20)) 360deg)',
  green_glass_border_grad: 'conic-gradient(from 180deg at 50% 50%, var(--White-20, rgba(255, 255, 255, 0.20)) 1.7291222512722015deg, var(--Neon-Green, #A7FF46) 126.34762287139893deg, var(--White-20, rgba(255, 255, 255, 0.20)) 360deg)',


  neon_yellow: '#F0FF46',
  neon_green: '#A7FF46',

  accent: '#81C73D',
  dark: '#33523E',

  lightDark:'#9A9E9B',
  pale_accent: '#CFDEC1',
};


